import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Address } from '@mwe/models';
import { getAddressPostCodeAndStreetFormatted } from '@mwe/utils';
import { NgClass } from '@angular/common';
import { ProductIconComponent } from '../../product-icon/product-icon.component';

@Component({
  selector: 'mwe-card-with-product-list',
  templateUrl: './card-with-product-list.component.html',
  imports: [NgClass, ProductIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardWithProductListComponent {
  categories = input.required<string[]>();
  address = input.required<Address>();
  description = input.required<string>();
  noBox = input<boolean>(false);
  oneRow = input<boolean>(true);

  postCodeAndStreet = computed(() => getAddressPostCodeAndStreetFormatted(this.address()));
}
